import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 py-2 bg-white border-b-4 border-indigo-600" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 6H20M4 12H20M4 18H11",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"relative mx-4 lg:mx-0\"><span class=\"absolute inset-y-0 left-0 flex items-center pl-3\"><svg class=\"w-5 h-5 text-gray-500\" viewBox=\"0 0 24 24\" fill=\"none\"><path d=\"M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></span><input class=\"w-32 pl-10 pr-4 py-2 text-indigo-600 border-gray-200 rounded-md sm:w-64 focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500\" type=\"text\" placeholder=\"Search\"></div>", 1)
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  class: "absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl overflow-hidden z-10",
  style: {"width":"20rem"}
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<a href=\"#\" class=\"flex items-center px-4 py-3 text-gray-600 hover:text-white hover:bg-indigo-600 -mx-2\"><img class=\"h-8 w-8 rounded-full object-cover mx-1\" src=\"https://images.unsplash.com/photo-1552774021-9ebbb764f03e?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=1000&amp;q=80\" alt=\"avatar\"><p class=\"text-sm mx-2\"><span class=\"font-bold\" href=\"#\">Evan Josh</span> replied on the <span class=\"font-bold text-indigo-400\" href=\"#\">Upload Image</span> artical . 2m </p></a><a href=\"#\" class=\"flex items-center px-4 py-3 text-gray-600 hover:text-white hover:bg-indigo-600 -mx-2\"><img class=\"h-8 w-8 rounded-full object-cover mx-1\" src=\"https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=634&amp;q=80\" alt=\"avatar\"><p class=\"text-sm mx-2\"><span class=\"font-bold\" href=\"#\">Slick Net</span> start following you . 45m </p></a><a href=\"#\" class=\"flex items-center px-4 py-3 text-gray-600 hover:text-white hover:bg-indigo-600 -mx-2\"><img class=\"h-8 w-8 rounded-full object-cover mx-1\" src=\"https://images.unsplash.com/photo-1450297350677-623de575f31c?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=334&amp;q=80\" alt=\"avatar\"><p class=\"text-sm mx-2\"><span class=\"font-bold\" href=\"#\">Jane Doe</span> Like Your reply on <span class=\"font-bold text-indigo-400\" href=\"#\">Test with TDD</span> artical . 1h </p></a><a href=\"#\" class=\"flex items-center px-4 py-3 text-gray-600 hover:text-white hover:bg-indigo-600 -mx-2\"><img class=\"h-8 w-8 rounded-full object-cover mx-1\" src=\"https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=crop&amp;w=398&amp;q=80\" alt=\"avatar\"><p class=\"text-sm mx-2\"><span class=\"font-bold\" href=\"#\">Abigail Bennett</span> start following you . 3h </p></a>", 4)
const _hoisted_16 = [
  _hoisted_12
]
const _hoisted_17 = { class: "relative" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "absolute right-0 z-20 w-48 py-1 mt-2 bg-white rounded-lg shadow-xl" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "px-4 py-2 flex rounded-md text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 mr-1",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Profile")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "flex rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-indigo-600 hover:text-white"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "h-5 w-5 mr-1",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "stroke-width": "2"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Settings")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 mr-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })
], -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Log out")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

import { ref, computed } from 'vue';
import { useSidebar } from "../hooks/useSidebar";
import { useStore } from "vuex";  // Import useStore untuk mengakses Vuex store

// Mengakses Vuex store

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();  
const dropdownOpen = ref(false);
const { isOpen } = useSidebar();
const notificationOpen = ref(false);

// Getter untuk currentUser
const currentUser = computed(() => store.getters.currentUser);

// Logout method
const logout = () => {
  document.cookie = "PSSID=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  window.location.href = '/login';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
        class: "text-gray-500 focus:outline-none lg:hidden"
      }, _hoisted_4),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (notificationOpen.value = !notificationOpen.value)),
            class: "flex mx-4 text-gray-600 focus:outline-none"
          }, _hoisted_10),
          _withDirectives(_createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (notificationOpen.value = false)),
            class: "fixed inset-0 h-full w-full z-10"
          }, null, 512), [
            [_vShow, notificationOpen.value]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, _hoisted_16, 512), [
            [_vShow, notificationOpen.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(_unref(currentUser)?.email) + " ", 1),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (dropdownOpen.value = !dropdownOpen.value)),
            class: "relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none"
          }, [
            _createElementVNode("img", {
              class: "object-cover w-full h-full",
              src: require('@/assets/image/logo.png'),
              alt: "Your avatar"
            }, null, 8, _hoisted_19)
          ])
        ]),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (dropdownOpen.value = false)),
          class: "fixed inset-0 z-10 w-full h-full"
        }, null, 512), [
          [_vShow, dropdownOpen.value]
        ]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-150 ease-out transform",
          "enter-from-class": "scale-95 opacity-0",
          "enter-to-class": "scale-100 opacity-100",
          "leave-active-class": "transition duration-150 ease-in transform",
          "leave-from-class": "scale-100 opacity-100",
          "leave-to-class": "scale-95 opacity-0"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("button", {
                onClick: logout,
                class: "flex px-4 py-2 rounded-md text-sm text-gray-700 hover:bg-indigo-600 hover:text-white w-full"
              }, _hoisted_25)
            ], 512), [
              [_vShow, dropdownOpen.value]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})